<template>
  <div class="matching-subscriptions-table">
    <AgGrid :options="gridOptions" :row-data="filteredSubscriptions" @row-selected="selectRow" @ready="tableReady">
      <template #header>
        <div class="text-subtitle-2 text-secondary-1">Subscriptions matching selected currency:</div>
      </template>
    </AgGrid>
  </div>
</template>

<script>
// Mixins
import { gridOptions } from './options'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [gridOptions],

  props: {
    subscriptionPeriods: Array,
    currency: String
  },

  data: () => ({
    agGrid: null,
    selectedSubscriptions: []
  }),

  computed: {
    filteredSubscriptions() {
      return this.subscriptionPeriods.filter(item => item.currency === this.currency)
    }
  },

  watch: {
    currency() {
      if (this.agGrid) this.clearSelectionAndSelectAll()
    },

    selectedSubscriptions(newVal) {
      const subPricesSum = newVal.reduce((acc, curr) => (acc += Number(curr.price)), 0)
      this.$emit('prices-sum', subPricesSum ? subPricesSum : null)
      this.$emit('selected-subs-count', newVal.length)
    }
  },

  methods: {
    // access from parent
    getSelectedSubsIds() {
      return this.selectedSubscriptions.map(sub => sub.id)
    },

    tableReady(agGrid) {
      this.clearSelectionAndSelectAll()
      this.agGrid = agGrid
    },

    clearSelectionAndSelectAll() {
      this.$nextTick(() => {
        this.selectedSubscriptions = []
        this.agGrid.api.selectAll()
      })
    },

    selectRow({ row, isSelected }) {
      if (isSelected) this.selectedSubscriptions.push(row)
      else this.selectedSubscriptions = this.selectedSubscriptions.filter(sub => sub.id !== row.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.matching-subscriptions-table {
  @include table-with-no-filters;
}
</style>
